function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import { i18n, MetadataActions, MetadataConstants, MetadataSelectors, PermissionService, SessionSelectors } from 'invision-core';
import * as CustomerSelectors from '../../../reducers/selectors/customer.selectors';
import * as CustomerDevicesSelector from '../../../reducers/selectors/customer.devices.selectors';
import CustomerCareLocaleKeys from '../../../locales/keys';
import * as CustomerDevicesActions from '../../../reducers/actions/customer.devices.actions';
import { DEVICE_MANAGEMENT_ACCESS } from '../../../security.attributes';
var mapStateToTarget = function mapStateToTarget(store) {
  return {
    currentCustomerId: CustomerSelectors.CurrentCustomerIdSelector(store),
    currentDevices: CustomerDevicesSelector.CurrentDevicesSelector(store),
    currentFormattedDevices: CustomerDevicesSelector.FormattedDevicesSelector(store),
    currentParams: CustomerSelectors.RouteParams(store),
    currentRoute: CustomerSelectors.RouteState(store),
    deviceCodesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.DeviceType, store),
    deviceErrors: CustomerDevicesSelector.DeviceErrorsSelector(store),
    deviceForm: CustomerDevicesSelector.DeviceFormSelector(store),
    formError: CustomerDevicesSelector.DeviceFormErrorSelector(store),
    includeRemoved: CustomerDevicesSelector.IncludeRemovedSelector(store),
    isRegisteringDevice: CustomerDevicesSelector.IsRegisteringDevicesSelector(store),
    isFetchingDevices: CustomerDevicesSelector.IsFetchingDevicesSelector(store),
    isRemovingDevice: CustomerDevicesSelector.IsRemovingDeviceSelector(store),
    isUpdatingDevice: CustomerDevicesSelector.IsUpdatingDevicesSelector(store),
    physicalDeviceCodesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.PhysicalDeviceType, store),
    remainingAssociations: CustomerDevicesSelector.RemainingDeviceAssociations(store),
    selectedDevice: CustomerDevicesSelector.FormattedSelectedDeviceSelector(store),
    userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store)
  };
};
var controllerActions = {
  clearDeviceForm: CustomerDevicesActions.clearDeviceForm,
  retrieveCustomerDevices: CustomerDevicesActions.retrieveCustomerDevices,
  fetchCodeType: MetadataActions.codes.fetchCodeTypes,
  registerDevice: CustomerDevicesActions.registerDevice,
  removeDevice: CustomerDevicesActions.removeDevice,
  setIncludedFilter: CustomerDevicesActions.setIncludedFilter,
  setDeviceForm: CustomerDevicesActions.setDeviceForm,
  setSelectedDevice: CustomerDevicesActions.setSelectedDevice,
  stateGo: stateGo,
  updateDevice: CustomerDevicesActions.updateDevice
};
var CustomerDevicesController = /*#__PURE__*/function () {
  function CustomerDevicesController($ngRedux, uiNotificationService, $timeout) {
    _classCallCheck(this, CustomerDevicesController);
    this.$ngRedux = $ngRedux;
    this.uiNotificationService = uiNotificationService;
    this.$timeout = $timeout;
  }
  return _createClass(CustomerDevicesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.localeKeys = CustomerCareLocaleKeys;
      this.labels = {
        registerSuccess: i18n.translate(this.localeKeys.DEVICE.REGISTER_SUCCESS),
        removeSuccess: i18n.translate(this.localeKeys.DEVICE.REMOVE_SUCCESS),
        updateSuccess: i18n.translate(this.localeKeys.DEVICE.UPDATE_SUCCESS)
      };
      this.unlimitedAssociations = i18n.translate(this.localeKeys.DEVICE.UNLIMITED);
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.retrieveCurrentDevices();
      if (!this.state.deviceCodesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.DeviceType);
      }
      if (!this.state.physicalDeviceCodesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.PhysicalDeviceType);
      }
      this.registerDevicePopUp = {
        onRegisterApi: function onRegisterApi(evt) {
          _this.registerDevicePopUp = Object.assign({}, evt.api, {
            open: function open() {
              _this.showRegisterForm = true;
              _this.$timeout(function () {
                evt.api.open();
              });
            },
            close: function close() {
              _this.showRegisterForm = false;
              evt.api.close();
            }
          });
        }
      };
      this.removeDevicePopUp = {
        onRegisterApi: function onRegisterApi(evt) {
          _this.removeDevicePopUp = evt.api;
        }
      };
      this.updateDevicePopUp = {
        onRegisterApi: function onRegisterApi(evt) {
          _this.updateDevicePopUp = Object.assign({}, evt.api, {
            open: function open() {
              _this.showUpdateForm = true;
              _this.$timeout(function () {
                evt.api.open();
              });
            },
            close: function close() {
              _this.showUpdateForm = false;
              evt.api.close();
            }
          });
        }
      };
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "closeRegisterDevicePopUp",
    value: function closeRegisterDevicePopUp() {
      this.registerDevicePopUp.close();
      this.actions.clearDeviceForm();
    }
  }, {
    key: "closeRemoveDevicePopUp",
    value: function closeRemoveDevicePopUp() {
      this.removeDevicePopUp.close();
    }
  }, {
    key: "closeUpdateDevicePopUp",
    value: function closeUpdateDevicePopUp() {
      this.updateDevicePopUp.close();
      this.actions.clearDeviceForm();
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this.state.isFetchingDevices || !this.state.deviceCodesLoaded || !this.state.physicalDeviceCodesLoaded || this.state.isRemovingDevice;
    }
  }, {
    key: "onDeviceFormChange",
    value: function onDeviceFormChange(deviceForm) {
      this.actions.setDeviceForm(deviceForm);
    }
  }, {
    key: "openRegisterDevicePopUp",
    value: function openRegisterDevicePopUp() {
      this.registerDevicePopUp.open();
    }
  }, {
    key: "openUpdateDevicePopUp",
    value: function openUpdateDevicePopUp() {
      this.onDeviceFormChange(this.state.selectedDevice);
      this.updateDevicePopUp.open();
    }
  }, {
    key: "onRemoveDevice",
    value: function onRemoveDevice(result) {
      var _this2 = this;
      this.closeRemoveDevicePopUp();
      if (result) {
        return this.actions.removeDevice(this.state.currentCustomerId, this.state.selectedDevice.DeviceId).then(function () {
          _this2.uiNotificationService.success(_this2.labels.removeSuccess, null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
          _this2.retrieveCurrentDevices();
        }).catch(function () {
          if (_this2.state.deviceErrors) {
            _this2.uiNotificationService.error(_this2.state.deviceErrors.message, null, {
              timeOut: NOTIFICATION_TIME_LENGTH
            });
          }
        });
      }
    }
  }, {
    key: "openRemoveDevicePopUp",
    value: function openRemoveDevicePopUp() {
      this.removeDevicePopUp.open();
    }
  }, {
    key: "registerDevice",
    value: function registerDevice() {
      var _this3 = this;
      return this.actions.registerDevice(this.state.currentCustomerId, this.state.deviceForm).then(function (response) {
        _this3.uiNotificationService.success(_this3.labels.registerSuccess, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
        _this3.closeRegisterDevicePopUp();
        return _this3.retrieveCurrentDevices().then(function () {
          _this3.actions.setSelectedDevice(response.PhysicalDevice);
        });
      });
    }
  }, {
    key: "retrieveCurrentDevices",
    value: function retrieveCurrentDevices() {
      var _this4 = this;
      return this.actions.retrieveCustomerDevices(this.state.currentCustomerId, this.state.includeRemoved).then(function () {
        if (!_this4.state.selectedDevice) {
          _this4.actions.setSelectedDevice(_this4.state.currentDevices[0]);
        }
      }).catch(function () {
        if (_this4.state.deviceErrors) {
          _this4.uiNotificationService.error(_this4.state.deviceErrors.message, null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }
      });
    }
  }, {
    key: "onDeviceSelected",
    value: function onDeviceSelected(device) {
      this.actions.setSelectedDevice(device);
    }
  }, {
    key: "remainingAssociations",
    value: function remainingAssociations() {
      return Number.isInteger(this.state.remainingAssociations) ? this.state.remainingAssociations : this.unlimitedAssociations;
    }
  }, {
    key: "onIncludeRemovedChange",
    value: function onIncludeRemovedChange() {
      this.actions.setIncludedFilter(!this.state.includeRemoved);
      this.retrieveCurrentDevices();
    }
  }, {
    key: "updateDevice",
    value: function updateDevice() {
      var _this5 = this;
      return this.actions.updateDevice(this.state.currentCustomerId, this.state.deviceForm).then(function () {
        _this5.uiNotificationService.success(_this5.labels.updateSuccess, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
        _this5.closeUpdateDevicePopUp();
        _this5.retrieveCurrentDevices();
      });
    }
  }, {
    key: "userCanEdit",
    get: function get() {
      return PermissionService.hasAdminAccess(this.state.userSecurityAttributes, DEVICE_MANAGEMENT_ACCESS);
    }
  }]);
}();
export default {
  template: require('./devices.html'),
  controller: CustomerDevicesController
};